var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VasionFolderSelect',{attrs:{"title":"Move Documents","okButtonText":"Move"},on:{"cancelButtonClick":_vm.cancelClick,"okButtonClick":_vm.moveClick}})}
var staticRenderFns = []

export { render, staticRenderFns }